{
    "page": 1,
    "size": 10,
    "total": 9,
    "total_pages": 1,
    "data": [
        {
            "name": "INGRID GUADALUPE",
            "last_name": "ESPINOZA",
            "last_name_2": "ESPINOZA",
            "rfc": "EIE1810907QDO",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 150,
            "porcent": 0.0039,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": 3,
            "variable_capital_shares": 0,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "57573164-1552-46cb-9425-6d80fc2bd0e6",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "VANYA AYSHA",
            "last_name": "MEDINA",
            "last_name_2": "DOMINGUEZ",
            "rfc": "NA",
            "email": "jhumberto604@gmail.com",
            "curp": "MEDV970627MSLDMN05",
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": "EMPRESARIA",
            "code_phone_number": "+52",
            "phone_number": "6672046883",
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 0,
            "porcent": 0,
            "information_person_completed": true,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": false,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": null,
            "variable_capital_shares": null,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "COMPLETO",
            "bank_references_status": "PENDIENTE",
            "person_types": ["335f2beb-69cb-4cd1-be34-d4db5a4abe49", "f71bd428-d77a-4e2f-8d22-6237dcd8d517"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "580661aa-1075-4ca2-9241-298f2ef8d1b7",
            "person_types_detail": [
                {
                    "name": "Otro",
                    "description": "Otro",
                    "code": "PTOT",
                    "tax_system_type": null,
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "335f2beb-69cb-4cd1-be34-d4db5a4abe49",
                    "use_for_rol": true,
                    "tax_systems_id": null,
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                },
                {
                    "name": "Cónyuge Aval",
                    "description": "Cónyuge Aval",
                    "code": "PTCAV",
                    "tax_system_type": null,
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "f71bd428-d77a-4e2f-8d22-6237dcd8d517",
                    "use_for_rol": false,
                    "tax_systems_id": null,
                    "is_for_signature": true,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "JESSICA",
            "last_name": "CASTRO",
            "last_name_2": "AISPURO",
            "rfc": "CAAJ940813KE5",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 250,
            "porcent": 0.0066,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": 5,
            "variable_capital_shares": 0,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "6b907864-897a-4013-923f-26a4d08263ee",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "JESUS HERNAN",
            "last_name": "CASTRO",
            "last_name_2": "GASTELUM",
            "rfc": "CAGJ790920421",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 100,
            "porcent": 0.0026,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": 2,
            "variable_capital_shares": 0,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "70660182-f59f-4c8f-a446-8c6a637374f3",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "HECTOR ARNOLDO",
            "last_name": "PAREDES",
            "last_name_2": "CASTRO",
            "rfc": "PACH571217NN6",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 150,
            "porcent": 0.0039,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": 3,
            "variable_capital_shares": 0,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "7a20762b-5ec1-4b8b-a70a-1a33590963dd",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "JESUS HUMBERTO",
            "last_name": "CASTRO",
            "last_name_2": "CAMACHO",
            "rfc": "CACJ710727CA9",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 2000,
            "porcent": 0.0526,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": 40,
            "variable_capital_shares": 0,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "8fb0f816-b779-415d-81a3-df9a7ca6c8f2",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "JESSICA",
            "last_name": "AISPURO",
            "last_name_2": "CASTAÑOS",
            "rfc": "AICJ710114EJ1",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 250,
            "porcent": 0.0066,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": 5,
            "variable_capital_shares": 0,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "b24bda42-dc2a-4fff-9d92-0a3c801b663e",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        },
        {
            "name": "jesus humberto",
            "last_name": "castro",
            "last_name_2": "aispuro",
            "rfc": "CAAJ980604CL7",
            "email": "humberto.ca@freshharvest.info",
            "curp": "CAAJ980604HSLSSS04",
            "birth_state": 25,
            "birth_date": "1998-06-04T00:00:00",
            "sex": "MASCULINO",
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": "c7ea1c05-d63e-4002-9368-d9cbe28c22ed",
            "occupation": "empresario",
            "code_phone_number": "+52",
            "phone_number": "6674738414",
            "completed": true,
            "own_account": true,
            "own_resources": true,
            "pep_shareholder": false,
            "pep_members": false,
            "matrimonial_regimes_id": "1468ed68-f91f-4f69-83a5-4d69eb79c94e",
            "total_value": 3800700,
            "porcent": 99.9211,
            "information_person_completed": true,
            "identity_validation_completed": true,
            "bank_references_completed": true,
            "metamap_identity": "694c3d6c3c69e1d9cf5ee94b",
            "is_aval_onboarding": true,
            "is_shareholder": true,
            "charge": "PRESIDENTE DEL CONSEJO DE ADMINISTRACION",
            "identification_number": "194656997",
            "validity_year": 2029,
            "nacionality": "MEXICANO",
            "birth_country": "MEXICO",
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": [
                "c06be20b-114b-43bb-8d44-022e4a088426",
                "f76b128e-fe0a-4a00-b0e5-866552d40a58",
                "0f2464ec-7685-4646-a49e-c8afee102dbe"
            ],
            "signature_documents_list": [
                "3f307d8b-c190-45a7-b467-1ec2628de1df",
                "406f6d79-890f-4276-a59f-1de10cbd04c9",
                "5bbdb651-dbda-4e69-91ba-df30b5b46cd0",
                "70eb4479-d677-4917-b32c-8bf8e6f590c1",
                "a4109465-f4a3-4611-a181-7e17638fa2eb",
                "acb703aa-256b-4849-87af-ec5d143fc1ba",
                "b99f3979-a060-441b-b9e7-5f9342e29aaf",
                "c2c2761b-785e-4b64-ac89-d020711d8b9f",
                "c8e1666f-9cb5-441b-b7c5-0d5a9cd36acf",
                "d124575a-c8f3-41c4-afe9-95cf20678b0a",
                "d3152915-5962-4ca8-a976-2448a4627409",
                "fa44f444-4882-48a3-af9c-9a49af3fa11e"
            ],
            "phone_verified": null,
            "fixed_capital_shares": 40,
            "variable_capital_shares": 76014,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": "116596b8-a270-405b-89b2-0bfc0aa193b9",
            "personal_information_status": "VALIDADO",
            "bank_references_status": "VALIDADO",
            "person_types": [
                "f76b128e-fe0a-4a00-b0e5-866552d40a58",
                "c06be20b-114b-43bb-8d44-022e4a088426",
                "0f2464ec-7685-4646-a49e-c8afee102dbe",
                "e12ca7d8-feac-40d5-abe4-e021aa28a306"
            ],
            "spouse_id": "883b0d3d-97de-419c-b09b-f348f26a3496",
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "bff74e85-7c4d-4b33-b177-a619e9ddb97c",
            "person_types_detail": [
                {
                    "name": "Representante Legal",
                    "description": "Representante Legal",
                    "code": "PTRL",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "f76b128e-fe0a-4a00-b0e5-866552d40a58",
                    "use_for_rol": false,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": true,
                    "created_at": "2025-08-26T02:37:34.357000"
                },
                {
                    "name": "Propietario Real",
                    "description": "Propietario Real",
                    "code": "PTPR",
                    "tax_system_type": null,
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "c06be20b-114b-43bb-8d44-022e4a088426",
                    "use_for_rol": false,
                    "tax_systems_id": null,
                    "is_for_signature": true,
                    "created_at": "2025-08-26T02:37:34.357000"
                },
                {
                    "name": "Accionista mayoritario",
                    "description": "Accionista Mayoritario",
                    "code": "PTAM",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "0f2464ec-7685-4646-a49e-c8afee102dbe",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": true,
                    "created_at": "2025-08-26T02:37:34.357000"
                },
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": {
                "last_name_2": "DOMINGUEZ",
                "civil_status_id": null,
                "pep_members": null,
                "bank_references_completed": null,
                "issuing_entity": null,
                "representation_type_legal_representative_id": null,
                "updated_at": "2026-01-05T23:06:35.910489",
                "rfc": "NA",
                "occupation": "EMPRESARIA",
                "matrimonial_regimes_id": null,
                "metamap_identity": null,
                "identification_type": null,
                "personal_information_status": "COMPLETO",
                "email": "jhumberto604@gmail.com",
                "code_phone_number": "+52",
                "total_value": 0,
                "is_aval_onboarding": null,
                "signature_roles_list": null,
                "bank_references_status": "PENDIENTE",
                "curp": "MEDV970627MSLDMN05",
                "phone_number": "6672046883",
                "porcent": 0,
                "is_shareholder": false,
                "signature_documents_list": null,
                "person_types": ["335f2beb-69cb-4cd1-be34-d4db5a4abe49", "f71bd428-d77a-4e2f-8d22-6237dcd8d517"],
                "birth_state": null,
                "completed": false,
                "information_person_completed": true,
                "charge": null,
                "phone_verified": null,
                "spouse_id": null,
                "name": "VANYA AYSHA",
                "birth_date": null,
                "own_account": null,
                "identity_validation_completed": null,
                "identification_number": null,
                "fixed_capital_shares": null,
                "is_credit_bureau_authorization_pf_sended": null,
                "id": "883b0d3d-97de-419c-b09b-f348f26a3496",
                "sex": null,
                "own_resources": null,
                "validity_year": null,
                "birth_country": null,
                "variable_capital_shares": null,
                "is_credit_bureau_authorization_pf_correct": null,
                "last_name": "MEDINA",
                "loan_application_id": "941c44fa-37da-4fcd-9525-e3aed5e1659f",
                "pep_shareholder": null,
                "nacionality": null,
                "fiel_serial_number": null,
                "created_at": "2025-12-24T19:49:08.318787",
                "matrimonial_regime": null
            },
            "matrimonial_regime": {
                "id": "1468ed68-f91f-4f69-83a5-4d69eb79c94e",
                "name": "Separación de Bienes",
                "description": "Separación de Bienes",
                "code": "RSB",
                "active": true
            }
        },
        {
            "name": "MARTHA CESILIA ",
            "last_name": "VALENZUELA",
            "last_name_2": "SOTELO",
            "rfc": "VASM7006066L7",
            "email": null,
            "curp": null,
            "birth_state": null,
            "birth_date": null,
            "sex": null,
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "civil_status_id": null,
            "occupation": null,
            "code_phone_number": null,
            "phone_number": null,
            "completed": false,
            "own_account": null,
            "own_resources": null,
            "pep_shareholder": null,
            "pep_members": null,
            "matrimonial_regimes_id": null,
            "total_value": 100,
            "porcent": 0.0026,
            "information_person_completed": null,
            "identity_validation_completed": null,
            "bank_references_completed": null,
            "metamap_identity": null,
            "is_aval_onboarding": null,
            "is_shareholder": true,
            "charge": null,
            "identification_number": null,
            "validity_year": null,
            "nacionality": null,
            "birth_country": null,
            "issuing_entity": null,
            "identification_type": null,
            "signature_roles_list": null,
            "signature_documents_list": null,
            "phone_verified": null,
            "fixed_capital_shares": null,
            "variable_capital_shares": null,
            "fiel_serial_number": null,
            "representation_type_legal_representative_id": null,
            "personal_information_status": "PENDIENTE",
            "bank_references_status": "PENDIENTE",
            "person_types": ["e12ca7d8-feac-40d5-abe4-e021aa28a306"],
            "spouse_id": null,
            "is_credit_bureau_authorization_pf_sended": null,
            "is_credit_bureau_authorization_pf_correct": null,
            "created_at": "2026-02-23T23:56:14.089658",
            "updated_at": "2026-02-23T23:56:14.089710",
            "id": "e64c8710-ba00-429a-8cae-138c246e9c99",
            "person_types_detail": [
                {
                    "name": "Accionista",
                    "description": "Accionista o Aval",
                    "code": "PTACAV",
                    "tax_system_type": "PM",
                    "active": true,
                    "updated_at": "2025-08-26T02:37:37.505000",
                    "id": "e12ca7d8-feac-40d5-abe4-e021aa28a306",
                    "use_for_rol": true,
                    "tax_systems_id": "78303173-1288-411f-8692-ebec2b6d75ae",
                    "is_for_signature": null,
                    "created_at": "2025-08-26T02:37:34.357000"
                }
            ],
            "spouse": null,
            "matrimonial_regime": null
        }
    ]
}
